<!--
 * @Author: your name
 * @Date: 2020-07-11 23:05:14
 * @LastEditTime: 2020-08-16 11:25:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admin-page-svn\src\views\bigScreen\components\KeywordChart.vue
-->
<template>
  <dv-border-box-9>
    <h2 class="title">最新告警信息</h2>
    <div class="warning-wrapper">
      <dv-scroll-board :config="config" style="width: 600px; height: 300px; padding: 0 8px" />
    </div>
    <!-- <div
      ref="wordCloud"
      style="width: 580px; height:300px;margin: 0 10px;"
    ></div>-->
  </dv-border-box-9>
</template>

<script>
import { getAction } from '@/api/manage'
// require('echarts-wordcloud')
export default {
  name: 'KeywordChartPerson',
  data() {
    return {
      /* option: {
        left: 'center',
        top: 'center',        
        tooltip: {
          textStyle: {
            color: '#FFF'
          }
        },
        series : [
          {  
            type : 'wordCloud',  
            shape:'smooth',  
            drawOutOfBound: true,
            gridSize : 15, 
            sizeRange : [16, 16 ],
            rotationRange: [0, 40],
            textStyle : {  
              normal : {  
                color :function (d) {
                  return 'rgba(0,153,255,'+(d.value/1000)+ ')';
                }
              },  
              emphasis : {  
                shadowBlur : 10,  
                shadowColor : '#333'  
              }  
            },  
            data : []
          }
        ]
      }, */
      config: { data: [] },
      url: {
        warnList: '/show/bigScreen/getWarnList',
      },
      projectId: null,
    }
  },
  async mounted() {},
  methods: {
    // 重新加载数据
    reloadData(projectId) {
      this.projectId = projectId
      this.loadData()
    },
    // 加载数据 渲染视图
    async loadData() {
      if (!this.projectId) {
        return
      }
      const result = await this.getWarnList()
      const { warnList } = result.result
      console.log(warnList)
      // this.setRenderChartData(warnList, this.option)
      const list = this.buildWarningList(warnList)
      this.config = {
        data: list,
        oddRowBGC: 'transparent',
        evenRowBGC: 'rgb(0, 186, 255)',
        columnWidth: [200, 120],
      }
      /* const wordCloud = this.$echarts.init(this.$refs.wordCloud);
    wordCloud.setOption(this.option) */
    },
    /**
     * @description: 获取服务数据
     * @param {undefined}
     * @return {Promise}
     */
    async getWarnList() {
      // 171
      return await getAction(this.url.warnList + '?projectId=' + this.projectId)
    },
    /**
     * @description: 设置图表悬殊
     * @param {list: Array, op: Object}
     * @return {undefined}
     */
    /* setRenderChartData(list, op){
      const newList = list.map(item => {
        return { name: item, value: Math.random()*1000 }
      })
      op.series[0].data = newList
    } */
    buildWarningList(list) {
      return list.map((item) => {
        return item.split('；')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.title {
  text-align: center;
  margin: 0;
  padding-top: 18px;
  color: #96bbda;
  font-size: 24px;
  font-weight: 500;
}
::v-deep.dv-border-box-9 .border-box-content {
  padding: 24px;
}
</style>
